import { Component, Inject, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ToastService } from 'src/app/services/toast.service';
import { SensorService } from 'src/app/services/sensor.service';

export interface EditSensorDialogData {
    id: string;
    name: string;
}

@Component({
  standalone: false,
    selector: 'app-edit-sensor-dialog-component',
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './editSensorDialog.component.html',
})
export class EditSensorDialogComponent implements OnDestroy {

    isLoading = false;

    constructor(public dialogRef: MatDialogRef<EditSensorDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: EditSensorDialogData,
        private sensorService: SensorService,
        private toastService: ToastService) {
    }

    save() {
        this.isLoading = true;
        this.sensorService.updateSensor(this.data)
            .subscribe(response => {
                this.isLoading = false;
                this.toastService.showSuccess('Sensor saved successfully', true);
                this.dialogRef.close(true);
            }, error => {
                this.isLoading = false;
                this.toastService.showError(error);
            });
    }

    ngOnDestroy() {
    }
}
